var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseMenuIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.082 12.5l4.713-4.713a.699.699 0 000-.988L17.7 5.704a.699.699 0 00-.988 0L12 10.418 7.287 5.705a.699.699 0 00-.988 0L5.204 6.799a.699.699 0 000 .988L9.917 12.5l-4.713 4.713a.699.699 0 000 .988L6.3 19.296a.7.7 0 00.987 0L12 14.583l4.713 4.712a.699.699 0 00.988 0l1.095-1.095a.7.7 0 000-.988L14.082 12.5z",
    fill: "#777"
  })));
}

export default SvgCloseMenuIcon;